function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStormy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.042 512.042",
    style: {
      enableBackground: "new 0 0 512.042 512.042"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99B9D9"
    },
    d: "M481.021,150c0,49.501-40.499,90-90,90l-165-21L109.02,204c-11.699-15.599-17.999-34.499-17.999-54   c0-49.501,40.499-90,90-90c3.3,0,6.599,0.3,9.901,0.601c7.8-17.1,20.099-31.501,35.099-41.7c17.1-12.001,37.8-18.9,60-18.9   c41.4,0,77.999,23.699,95.099,60.601C433.32,54.901,481.021,97.2,481.021,150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99B9D9"
    },
    d: "M481.021,150c0,49.501-40.499,90-90,90l-165-21V18.9c17.1-12.001,37.8-18.9,60-18.9   c41.4,0,77.999,23.699,95.099,60.601C433.32,54.901,481.021,97.2,481.021,150z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3394F6"
    },
    d: "M346.021,512c-24.814,0-45-20.186-45-45c0-7.91,2.08-15.688,6.006-22.485l26.001-45.015    c5.361-9.287,20.625-9.287,25.986,0l26.001,45.015c3.94,6.855,6.006,14.619,6.006,22.485C391.021,491.814,370.835,512,346.021,512    z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD9F1"
    },
    d: "M321.12,181.601C304.02,144.699,267.421,121,226.021,121s-77.999,23.699-95.099,60.601    c-52.5-5.7-99.901,36.599-99.901,89.399c0,49.501,40.499,90,90,90h210c49.501,0,90-40.499,90-90    C421.021,218.2,373.62,175.901,321.12,181.601z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD9F1"
    },
    d: "M421.021,271c0,49.501-40.499,90-90,90h-105V121c41.4,0,77.999,23.699,95.099,60.601   C373.62,175.901,421.021,218.2,421.021,271z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#465C69"
    },
    d: "M256.021,331h-75v-75c0-15-20.099-20.7-27.9-7.8l-90,151c-6,10.199,1.199,22.8,12.9,22.8h75v75    c0,15.3,20.099,20.7,27.9,7.8l47.1-78.6l42.9-72.4C274.921,343.599,267.721,331,256.021,331z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#465C69"
    },
    d: "M268.921,353.8l-42.9,72.4V331h30C267.721,331,274.921,343.599,268.921,353.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormy);
export default __webpack_public_path__ + "static/media/stormy.9fcd64dee45521e6badd7ba7b9bf6f91.svg";
export { ForwardRef as ReactComponent };